

export class EFormConfiguration {
    ReadOnly = false;
    ShowSubmittedBy = false;
    Title = '';
    DisableSubmission = false;
    AlwaysShowAllConditionals = false;
    ViewMode: enmEFormViewModes = enmEFormViewModes.Template;
    ShowPrintButton = false;
    ParentHandlesSave = false;
    UseInstance = true;
    PageFlag = false;
    CustomFieldsFlag = false;
    HideTitle = false;
    IsSurvey = false;
    IsMobile = false;
    InformationalMessage = '';
    IsMobilePreview = false;
    BasePage = false;
    CSTObjectID: number;
    CSTFieldsManageOwnData = true;
    PersistCustomFieldDataInMemory = false;
    AllowTabs = true;
    AllowPages = true;
    AllowConditionalObjects = true;
    AllowInstanceSpecificText = false;
    IsPreview = false;
    NewForm = false;
    PageObjectType = '';
    AllowAttachmentControls = true;
    HideLanguageDropDown = false;
    ShowHeader = false;
    HeaderSelectedLogo = 0;
    ShowHeaderSchoolName = false;
    ShowHeaderSchoolAddress = false;
}

export enum enmEFormViewModes {
    Template = 'template',
    Instance = 'instance',
    Review = 'review',
    Form = 'form',
    Page = 'page',
    CustomPage = 'customPage',
    FRMA = 'frma'
}

export enum PageObjectTypes {
    Student = 'student',
    Staff = 'staff',
    Other = 'other'
}